export const ADD_BLOCK_MIN_WEEKS = 1;
export const ADD_BLOCK_MAX_WEEKS = 24;
export const ADD_BLOCK_DEFAULT_WEEKS = 6;

const resolveWeeksBounds = ({ min, max } = {}) => {
  const resolvedMin = Number.isFinite(min) ? min : ADD_BLOCK_MIN_WEEKS;
  const resolvedMax = Number.isFinite(max) ? max : ADD_BLOCK_MAX_WEEKS;

  return {
    min: resolvedMin,
    max: Math.max(resolvedMin, resolvedMax),
  };
};

export const parseWeeksValue = (value) => {
  if (typeof value === "number" && Number.isInteger(value)) return value;
  if (typeof value !== "string") return null;

  const trimmedValue = value.trim();
  if (!/^\d+$/.test(trimmedValue)) return null;

  const parsedValue = Number.parseInt(trimmedValue, 10);
  return Number.isFinite(parsedValue) ? parsedValue : null;
};

export const isWeeksValueValid = (value, options) => {
  const parsedValue = parseWeeksValue(value);
  if (parsedValue === null) return false;

  const { min, max } = resolveWeeksBounds(options);
  return parsedValue >= min && parsedValue <= max;
};

export const normalizeWeeksValue = (value, options) => {
  const { min, max } = resolveWeeksBounds(options);
  const fallbackValue = Number.isFinite(options?.fallback)
    ? options.fallback
    : ADD_BLOCK_DEFAULT_WEEKS;
  const parsedValue = parseWeeksValue(value);

  if (parsedValue === null) {
    return Math.min(Math.max(fallbackValue, min), max);
  }
  if (parsedValue < min) return min;
  if (parsedValue > max) return max;
  return parsedValue;
};

export const resolveWeeksForSave = (value, options) =>
  normalizeWeeksValue(value, options);

export const incrementWeeksValue = (value, options) =>
  normalizeWeeksValue(resolveWeeksForSave(value, options) + 1, options);

export const decrementWeeksValue = (value, options) =>
  normalizeWeeksValue(resolveWeeksForSave(value, options) - 1, options);

export const sanitizeWeeksInputDraft = (value) =>
  String(value ?? "")
    .replace(/\D/g, "")
    .slice(0, 2);

export const resolveWeeksDraftOnBlur = (value, options) =>
  String(resolveWeeksForSave(value, options));

export const normalizeFolderLabel = (value) =>
  typeof value === "string" ? value.trim() : "";
